import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { OnboardingLayout } from '../components/layout/OnboardingLayout'
import { DocumentationStep } from '../components/onboarding/steps/DocumentationStep'
import { authService } from '../services/authService'
import { guarantorService } from '../services/guarantorService'

const DocumentationPage: React.FC = () => {
  const navigate = useNavigate()
  const [personType, setPersonType] = React.useState<string | null>(null)
  const [userType, setUserType] = React.useState<string | null>(null)
  const [linkedAppId, setLinkedAppId] = React.useState<string | null>(null)
  // A partir de la 2da solicitud del usuario, este paso es parte del
  // recorrido abreviado (sin stepper, y salta directo a la pantalla de
  // revisión en vez de agendar visita).
  const [isRepeat, setIsRepeat] = React.useState(false)

  useEffect(() => {
    authService
      .isCurrentCreditApplicationTheFirst()
      .then(isFirst => setIsRepeat(!isFirst))
      .catch(() => setIsRepeat(false))
  }, [])

  useEffect(() => {
    const getAuthDataFromStorage = () => {
      try {
        const userData = localStorage.getItem('user_data')
        console.log('📦 Raw userData from localStorage:', userData)
        if (userData) {
          const user = JSON.parse(userData)
          console.log('👤 Parsed user object:', user)
          setUserType(user.userType || null)
          setLinkedAppId(user.linkedCreditApplicationId || null)
          return user.personType
        }
        return null
      } catch (error) {
        console.error('Error al obtener datos de usuario:', error)
        return null
      }
    }

    const pType = getAuthDataFromStorage()
    setPersonType(pType)
  }, [])

  let steps = [
    { id: '1', title: '', description: '', status: 'completed' as const },
    { id: '2', title: '', description: '', status: 'completed' as const },
    { id: '3', title: '', description: '', status: 'completed' as const },
    { id: '4', title: '', description: '', status: 'completed' as const },
    { id: '5', title: '', description: '', status: 'current' as const },
    { id: '6', title: '', description: '', status: 'pending' as const },
  ]

  if (personType === 'PFAE') {
    steps = [
      { id: '1', title: '', description: '', status: 'completed' as const },
      { id: '2', title: '', description: '', status: 'completed' as const },
      { id: '3', title: '', description: '', status: 'completed' as const },
      { id: '4', title: '', description: '', status: 'current' as const },
      { id: '5', title: '', description: '', status: 'pending' as const },
    ]
  }

  const handleNext = async () => {
    // Navigate to next step - Schedule Visit
    console.log('Documents uploaded, proceeding to next step')

    let nextUrl = '/onboarding/schedule-visit'

    if (userType === 'GUARANTOR') {
      nextUrl = '/onboarding/finished'

      // Finalizar onboarding del aval usando el linkedCreditApplicationId
      try {
        if (linkedAppId) {
          console.log('📍 Finalizing guarantor onboarding...')
          await guarantorService.finalizeOnboarding(linkedAppId)
          console.log('✅ Guarantor onboarding finalized')
        } else {
          console.warn('⚠️ No linkedCreditApplicationId found for guarantor')
        }
      } catch (finalizeError) {
        console.error(
          '❌ Error finalizing guarantor onboarding:',
          finalizeError
        )
        // Detener el flujo si ocurre un error al finalizar para el aval
        return
      }
    } else if (isRepeat) {
      // Recorrido abreviado (2da solicitud en adelante): se salta agendar
      // visita y va directo a la pantalla "en revisión". A diferencia del
      // aval, aquí no se llama a guarantorService.finalizeOnboarding — esa
      // finalización sigue siendo exclusiva del flujo de aval.
      nextUrl = '/onboarding/finished'
    }

    // Actualizar progressURL en credit-application después del éxito
    try {
      console.log('📍 Updating progressURL after successful document upload...')
      const creditAppId = await authService.getCurrentCreditApplicationId()

      if (creditAppId) {
        await authService.updateCreditApplicationProgress(creditAppId, nextUrl)
        console.log('✅ ProgressURL updated successfully to:', nextUrl)
      } else {
        console.warn(
          '⚠️ No credit application ID found, skipping progressURL update'
        )
      }
    } catch (progressError) {
      console.error('❌ Error updating progressURL:', progressError)
      // No detener el flujo si falla la actualización del progreso
    }

    navigate(nextUrl)
  }

  const handleCancel = () => {
    // navigate('/test-flows')
  }

  return (
    <OnboardingLayout steps={steps} showStepper={!isRepeat}>
      <DocumentationStep
        onNext={handleNext}
        onCancel={handleCancel}
        personType={personType}
      />
    </OnboardingLayout>
  )
}

export default DocumentationPage
